import React, { Component } from "react";
import _ from "lodash";
import { NotificationManager } from "react-notifications";

import ManageForm from "./Form";

import TagsAPI from "../../api/tags";
import ExhibitsAPI from "../../api/exhibits";

class ManageExhibit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      title: "",
      description: "",
      dataLoaded: false
    };
  }

  componentDidMount() {
    this.getTags();
  }

  clearForm = () => {
    this.setState({
      title: "",
      description: ""
    });

    this.props.history.replace("/manage");
  };

  getTags() {
    const tags = [];
    TagsAPI.getTags()
      .then(result => {
        const { data } = result;
        data.map(d => {
          const obj = {
            tag_id: d.tag_id,
            tag_name: d.tag_name,
            checked: false
          };
          tags.push(obj);
        });

        this.setState({ tags });
      })
      .then(() => {
        this.getDetails();
      });
  }

  getDetails() {
    const id = this.props.match.params.id || "";

    if (id !== "") {
      ExhibitsAPI.getDetails(id).then(result => {
        const { data } = result;
        const { tags } = this.state;

        data.map(d => {
          const i = _.findIndex(tags, t => t.tag_id == d.tag_id);
          tags[i].checked = true;
        });

        this.setState({
          title: data[0].exh_title,
          description: data[0].exh_desc,
          tags,
          dataLoaded: true
        });
      });
    } else {
      this.setState({ dataLoaded: true });
    }
  }

  onChange = e => {
    const { tags } = this.state;
    switch (e.target.name) {
      case "tag":
        const index = _.findIndex(tags, o => o.tag_id == e.target.value);
        tags[index].checked = e.target.checked;
        this.setState({ tags });
        break;
      case "title":
        this.setState({ title: e.target.value });
        break;
      default:
        return;
    }
  };

  onCKEditorChange = e => {
    this.setState({ description: e.editor.getData() });
  };

  onSubmit = e => {
    e.preventDefault();
    const { title, description, tags } = this.state;
    const selectedTags = [];
    const exhibitID = this.props.match.params.id || "";

    tags.map(t => {
      if (t.checked) {
        selectedTags.push(t.tag_id);
      }
    });

    const formData = {
      id: exhibitID,
      title,
      description,
      tags: JSON.stringify(selectedTags)
    };

    ExhibitsAPI.manageExhibit(formData).then(result => {
      NotificationManager.success("Exhibit saved successfully");
    });
  };

  render() {
    const { tags, title, description, dataLoaded } = this.state;

    return (
      <div>
        <ManageForm
          tags={tags}
          title={title}
          description={description}
          onChange={this.onChange}
          onCKEditorChange={this.onCKEditorChange}
          onSubmit={this.onSubmit}
          clearForm={this.clearForm}
          dataLoaded={dataLoaded}
        />
      </div>
    );
  }
}

export default ManageExhibit;



// WEBPACK FOOTER //
// ./src/pages/ManageExhibit/index.jsx